import React from 'react';
import { Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { styled } from '@mui/material/styles';
import { CustomButton } from './GemFilterModal';
import { GemFeature } from '../../../../utils/enums/gem-feature.enum';
import { theme } from '../../../../theme/theme';
import { GemColor } from '../../../../utils/enums/gem-color.enum';

export const colors = [
  {
    code: '#0005FB',
    name: GemColor.Blue,
  },
  {
    code: '#258014',
    name: GemColor.Green,
  },
  {
    code: '#ED3E41',
    name: GemColor.Red,
  },
  {
    code: '#248080',
    name: GemColor.Teal,
  },
  {
    code: '#EAA6D9',
    name: GemColor.Pink,
  },
  {
    code: '#87EDCE',
    name: GemColor.BiColor,
  },
  {
    code: '#CED0A7',
    name: GemColor.MultiColor,
  },
  {
    code: '#D30DFB',
    name: GemColor.Purple,
  },
  {
    code: '#FFFF3A',
    name: GemColor.Yellow,
  },
  {
    code: '#E883EC',
    name: GemColor.Violet,
  },
  {
    code: '#AE684A',
    name: GemColor.Brown,
  },
  {
    code: '#FAA629',
    name: GemColor.Orange,
  },
  {
    code: '#808080',
    name: GemColor.Grey,
  },
  {
    code: '#FEFEFE',
    name: GemColor.White,
  },
  {
    code: '#000000',
    name: GemColor.Black,
  },
  {
    code: '#E1E1E1',
    name: GemColor.Other,
  },
];

interface IStyledCircleIconProps {
  code: string;
  name: GemColor;
}

const StyledCircleIcon = styled(CircleIcon)<IStyledCircleIconProps>(({ code, name }) => ({
  color: code,
  width: 15,
  height: 15,
  stroke: name === GemColor.White ? theme.palette.common.white : 'none',
}));

interface IColorsProps {
  handleSelectOption: (_gemFeature: string, _value: string) => void;
  isSelected: (_gemFeature: string, _value: string) => boolean;
  type: string;
}

function Colors({ handleSelectOption, isSelected, type }: IColorsProps) {
  return colors.map((color) => (
    <CustomButton
      key={color.code}
      variant="outlined"
      onClick={() => handleSelectOption(type, color.name)}
      selected={isSelected(type, color.name)}
      startIcon={<StyledCircleIcon code={color.code} name={color.name} />}
    >
      <Typography variant="textBase500">{color.name} </Typography>
    </CustomButton>
  ));
}

export default Colors;
